import styles from '../styles.module.scss';
import { Image } from '@starsoft/common/components';
import skeleton from './styles.module.scss';
import RewardSubmitButton from '../../../SubmitButton';

export default function BonusClaimRewardModalContentRewardCardSkeleton() {
  return (
    <div className={styles.card}>
      <Image
        className={styles.card__icon}
        width={80}
        height={80}
        preload
        alt="rank"
        secondarySkeleton
      />

      <div className={styles.card__column}>
        <div className={styles.card__column__title}>
          <div className={skeleton.title} />
        </div>
        <div className={skeleton.spacer} />
        <div className={styles.card__column__description}>
          <div className={skeleton.description__wrapper}>
            <div className={skeleton.description} />
            <div
              className={`${skeleton.description} ${skeleton['description--half']}`}
            />
          </div>
        </div>
        <div className={styles.card__column__coin__chip}>
          <Image width={15} height={15} secondarySkeleton alt="coin" />
          <div className={styles.card__column__coin__label}>
            <div className={skeleton.value} />
          </div>
        </div>
      </div>
      <RewardSubmitButton isLoading />
    </div>
  );
}
